export const products = [
  {
    id: 1,
    title: "ADHD Task Chunker",
    price: " 5.00 € ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvcG5n/950e8a0f75c764419508195caf47fb7b.png",
    description: "Break down overwhelming tasks into manageable steps instantly.",
    url: "https://alienproduction.etsy.com/listing/4480557997/adhd-task-chunker-science-based"
  },
  {
    id: 2,
    title: "ADHD Content Planner Notion Template",
    price: " 10.00 € ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/fae123799af5b9eabf92eff812359eef.jpeg",
    description: "The ultimate system to organize your content creation without the chaos.",
    url: "https://alienproduction.etsy.com/listing/4481360371/adhd-content-planner-notion-template"
  },
  {
    id: 3,
    title: "Notion Video Script Template",
    price: " 15.00 € ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/e6379f5e6290ec3601553a753420fd76.jpeg",
    description: "Structure your videos perfectly every time for maximum retention.",
    url: "https://alienproduction.etsy.com/listing/4481711381/notion-video-script-template-custom"
  },
  {
    id: 4,
    title: "Freelancer CRM",
    price: " £19.00 ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/b8c61b7f3730bd89f93e4b383712de9d.jpeg",
    description: "The Anti-Ghosting CRM is a brutalist, high-velocity sales pipeline built specifically for solopreneurs and ADHD brains.",
    url: "https://alienproduction.etsy.com/listing/4482333398/notion-crm-template-freelance-sales"
  },
  {
    id: 5,
    title: "Client Portal Template",
    price: " £15.00 ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/543c7fe9eaf8715a3b9e34b19e4e8b7a.jpeg",
    description: "Stop building custom pages for every new client. Generate a clean, professional Client Hub with one click.",
    url: "https://alienproduction.etsy.com/listing/4482898536/notion-client-portal-template-freelance"
  },
  {
    id: 6,
    title: "Notion Link in Bio Template",
    price: " £2.00 ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/bfb22353899cc127f2c39c3d6484758b.jpeg",
    description: "A brutalist, mobile-optimized micro-website that guides visitors exactly where they need to go.",
    url: "https://alienproduction.etsy.com/listing/4484488252/notion-link-in-bio-template-minimalist"
  },
  {
    id: 7,
    title: "5 Day Email Sales Funnel",
    price: " £5.00 ",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/ee5dc18d6a20c89a4ee83f1246cbac16.jpeg",
    description: "The copy-and-paste blueprint to automate your follow-up and turn your audience into paying clients.",
    url: "https://alienproduction.etsy.com/listing/4484636419/5-day-email-sales-funnel-lead-magnet"
  },
  {
    id: 8,
    title: "Podcast Hub",
    price: "£10.00",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/461413e36031ffc387548e4a23c38744.jpeg",
    description: "Manage your Podcast and Guest in one sleek Hub",
    url: "https://alienproduction.etsy.com/listing/4487315790/podcast-planner-notion-relational-guest"
  },
  {
    id: 9,
    title: "Etsy Shop Planner",
    price: "£10.00",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/89062b92541d22e24f90804d58047516.jpeg",
    description: "Manage your Esty Listings, Keywords and keep Track",
    url: "https://alienproduction.etsy.com/listing/4486534006/etsy-shop-planner-notion-template"
  }
];